import { render, staticRenderFns } from "./SubjectOverviewNew.vue?vue&type=template&id=6bd6848f&scoped=true&"
import script from "./SubjectOverviewNew.ts?vue&type=script&lang=ts&"
export * from "./SubjectOverviewNew.ts?vue&type=script&lang=ts&"
import style0 from "./SubjectOverviewNew.scss?vue&type=style&index=0&id=6bd6848f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd6848f",
  null
  
)

export default component.exports